import { db } from "@/firebase";

const UserStore = {
  state: {
    currentUser: null,
    users: null
  },

  mutations: {
    SET_USERS(state, users) {
      state.users = users;
    },
    SET_CURRENT_USER (state, user) {
      state.currentUser = user
    },
    UPDATE_USER(state, user) {
      state.users[user.id] = user
    },
  },

  getters: {
    users: state => state.users,
    currentUser: state => state.currentUser,
    userById: state => id => {
      if (state.users) {
        return state.users.filter(user => {
          return user.id === id;
        })[0];
      }
    }
  },

  actions: {
    getUsers({ commit }) {
      return new Promise((resolve, reject) => {
        db.collection("users")
          .get()
          .then(
            querySnapshot => {
              let data = [];
              let index = 0;
              querySnapshot.forEach(function(doc) {
                let obj = doc.data();
                obj.id = doc.id;
                obj.index = index;
                data.push(obj);
                index++;
              });
              commit("SET_USERS", data);
            },
            error => {
              reject(error);
            }
          );
      });
    },
    updateUser ({commit}, user) {
      return new Promise((resolve, reject) => {
        db.collection("users")
          .doc(user.uid)
          .set(user)
          .then(function () {
            commit("UPDATE_USER", {user: user});
          })
          .catch(function (error) {
            reject(error);
          });
      });
    },
    getCurrentUser({ commit }, user) {
      return new Promise((resolve, reject) => {
        db.collection("users")
          .doc(user.uid)
          .get()
          .then(
            doc => {
              commit("SET_CURRENT_USER", doc.data());
              resolve()
            },
            error => {
              reject(error);
            }
          );
      });
    },
    syncUserDataWithLoginData({ commit }, loginData) {
      return new Promise( (resolve, reject) => {
        db.collection("users")
          .doc(loginData.uid)
          .get()
          .then(doc => {
            console.log(doc.exists)
            let user = doc.data()
            user.displayName = loginData.displayName
            user.lastName = loginData.lastName
            user.firstName = loginData.firstName
            user.email = loginData.email
            user.avatar = loginData.photoURL
            user.uid = loginData.uid
            db.collection("users")
              .doc(loginData.uid)
              .set(user)
            commit("SET_CURRENT_USER", doc.data());
            resolve()
            },
            error => {
              reject(error);
            })
      });
    }
  }
};

export default UserStore;
